var components = {'tnRowNotice': require('tuniao-ui/components/tn-row-notice/tn-row-notice.vue').default,'tnColumnNotice': require('tuniao-ui/components/tn-column-notice/tn-column-notice.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotice)?_c('v-uni-view',{staticClass:"tn-notice-bar-class tn-notice-bar",style:({
    borderRadius: _vm.radius + 'rpx'
  })},[(_vm.mode === 'horizontal' && _vm.circular)?[_c('tn-row-notice',{attrs:{"backgroundColor":_vm.backgroundColor,"fontColor":_vm.fontColor,"fontSize":_vm.fontSize,"fontUnit":_vm.fontUnit,"list":_vm.valueList,"show":_vm.show,"playStatus":_vm.playStatus,"leftIcon":_vm.leftIcon,"leftIconName":_vm.leftIconName,"leftIconSize":_vm.leftIconSize,"rightIcon":_vm.rightIcon,"rightIconName":_vm.rightIconName,"rightIconSize":_vm.rightIconSize,"closeBtn":_vm.closeBtn,"autoplay":_vm.autoplay,"radius":_vm.radius,"padding":_vm.padding,"speed":_vm.speed},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.click).apply(void 0, arguments)
},"close":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
},"clickLeft":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickLeftIcon).apply(void 0, arguments)
},"clickRight":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickRightIcon).apply(void 0, arguments)
}}})]:_vm._e(),(_vm.mode === 'vertical' || (_vm.mode === 'horizontal' && !_vm.circular))?[_c('tn-column-notice',{attrs:{"backgroundColor":_vm.backgroundColor,"fontColor":_vm.fontColor,"fontSize":_vm.fontSize,"fontUnit":_vm.fontUnit,"list":_vm.valueList,"show":_vm.show,"mode":_vm.mode,"playStatus":_vm.playStatus,"leftIcon":_vm.leftIcon,"leftIconName":_vm.leftIconName,"leftIconSize":_vm.leftIconSize,"rightIcon":_vm.rightIcon,"rightIconName":_vm.rightIconName,"rightIconSize":_vm.rightIconSize,"closeBtn":_vm.closeBtn,"autoplay":_vm.autoplay,"radius":_vm.radius,"padding":_vm.padding,"duration":_vm.duration},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.click).apply(void 0, arguments)
},"close":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.close).apply(void 0, arguments)
},"clickLeft":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickLeftIcon).apply(void 0, arguments)
},"clickRight":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.clickRightIcon).apply(void 0, arguments)
},"end":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.end).apply(void 0, arguments)
}}})]:_vm._e()],2):_vm._e()}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }